import { atom, selector } from 'recoil'

export const stepState = atom({
  key: 'step',
  default: 0
})

export const mobileState = atom<string>({
  key: 'mobile',
  default: ''
})

export const areaState = atom<string>({
  key: 'area',
  default: '+86'
})

export interface AreaType {
  area: string
  areaCode: string
}

export interface AreaGroupType {
  index: string
  list: AreaType[]
}

export const areaListState = atom<AreaGroupType[]>({
  key: 'areaList',
  default: []
})

// 是否需要滑块
export const needSliderState = atom<boolean>({
  key: 'needSlider',
  default: false
})

export const stepTxtState = selector({
  key: 'stepTxt',
  // get支持异步
  get: ({ get }) => {
    const step = get(stepState)
    let txt = ''
    switch (step) {
      case 0:
        txt = '登录'
        break
      case 1:
        txt = '密码登录'
        break
      case 2:
        txt = '注册领取试听课'
        break
      default:
        txt = '重置密码'
        break
    }
    return txt
  }
})
